import ProductionOrderList from './List';
import { ProductionOrderCreate, ProductionOrderEdit } from './Form';

export default {
  list: ProductionOrderList,
  create: ProductionOrderCreate,
  edit: ProductionOrderEdit,
};
